module.exports = __webpack_public_path__ + "assets/99a2ab855f6765e3d3ddf646aa9388d1.png";